import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <path d="M82.65 9.18c-11.81,9.76 -68.35,44.35 -65.17,56.49 2.87,10.3 4.15,14.85 7.02,25.15 2.3,-3.15 5.49,-3.07 8.24,-4.61 -5.9,-25.56 -0.88,-20.83 8.33,-18.79 6.89,1.52 27.28,3.91 33.69,-12.77 -2.57,2.72 -7.3,2.6 -12.64,1.43 8.73,-3.73 18.93,-5.82 16.59,-21.04 -2.68,4.98 -12,5.63 -14.7,6.35 15.27,-6.98 18.2,-23.92 18.64,-32.21z" />
</svg>